(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.faq-section .faq-question').forEach(function(question){
  question.addEventListener('click', function(){
    var item = this.parentElement;
    item.classList.toggle('active');
  });
});

  } catch(e) { console.error(e); }
})();
})();
